import { Dialog } from "@mui/material";
import Button from "components/common/Button";
import { setSelected, toggleGlobalSearchModal } from "store/slices/main.slice";
import SearchIcon from "@mui/icons-material/Close";
import Input from "components/common/Input";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useState } from "react";
import Loading from "components/common/Loading";
import ProductPopUp from "./ProductPopUp";
import api from "config/api";
import Product from "./Product";

const GlobalSearchProduct = () => {
  const dispatch = useAppDispatch();
  const showGlobalSearchModal = useAppSelector(
    ({ main }) => main.showGlobalSearchModal,
  );
  const [products, setproducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState<any>("");

  const fetchData = () => {
    if (search) {
      setLoading(true);
      setproducts([]);
      api
        .get(`/api/Product/ByName?name=${search}`)
        .then(({ data }) => {
          setproducts(data);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 200);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  return (
    <Dialog
      onClose={() => {
        dispatch(toggleGlobalSearchModal());
        setSearch("");
        setproducts([]);
      }}
      open={showGlobalSearchModal}
      maxWidth="md"
      fullWidth
      className="search-modal relative"
    >
      <div className="flex justify-end m-2">
        <Button
          className="bg-primary !text-dark-text !px-1 sm:!px-2 relative"
          onClick={() => {
            dispatch(toggleGlobalSearchModal());
            setSearch("");
            setproducts([]);
          }}
        >
          <SearchIcon className="!text-white cursor-pointer" />
        </Button>
      </div>
      <div className="sticky top-0 z-10 bg-white p-7 shadow-lg border border-t">
        <Input
          size="small"
          label="Search Product"
          className="w-full"
          sx={{ flex: 1 }}
          onValueChange={(e) => {
            setSearch(e);
          }}
          value={search}
          type="text"
        />
      </div>
      <div className="px-5 my-3 ">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 overflow-y-auto items-start max-h-full p-4 ">
          {products.map((item) => (
            <Product
              {...item}
              btnText={
                window.location.pathname.includes("admin")
                  ? "Edit"
                  : "Add to cart"
              }
              onClick={() => {
                dispatch(setSelected(item));
              }}
            />
          ))}
        </div>

        {loading && (
          <div className="h-44">
            <Loading />
          </div>
        )}

        <ProductPopUp />
      </div>
    </Dialog>
  );
};

export default GlobalSearchProduct;
